import React, { createContext, useState } from "react";
import { node } from "prop-types";
import { loginAPI } from "./api-services/login.service";
import { createFutureCustomer } from "./api-services/customer.service";

export const DataContext = createContext();

const DataProvider = ({ children }) => {
    // Loader
    const [isLoading, setLoader] = useState(false);

    // login api call
    const [loginResponse, setLoginResponse] = useState({
        isLoggedIn: false,
        error: null,
    });

    // zip code
    const [foundLocationState, setFoundLocationState] = useState({
        foundLocation: true,
        error: "Network Error",
    });


    // const onLogin = async (payload) => {
    //     await setLoader(true);
    //     await setLoginResponse({
    //         isLoggedIn: false,
    //     });
    //     const response = await loginAPI(payload);
    //     await setLoginResponse({
    //         ...loginResponse,
    //         ...response,
    //         isLoggedIn: response.success,
    //     });
    //     await setLoader(false);
    // };

    // create future customer api call
    const [createFutureCustomerData, setCreateFutureCustomerData] = useState({
        loading: false,
        success: false,
        data: null
    });

    const onCreateFutureCustomer = async (payload) => {
        setCreateFutureCustomerData({
            loading: true,
        });
        const response = await createFutureCustomer(payload);
        setCreateFutureCustomerData({
            ...response,
            loading: false,
            success: response.data.success
        });
    };

    return (
        <DataContext.Provider
            value={{
                loginResponse,
                // onLogin,
                onCreateFutureCustomer,
                createFutureCustomerData,
                setCreateFutureCustomerData,
                isLoading,
                foundLocationState,
                setFoundLocationState,
            }}
        >
            {children}
        </DataContext.Provider>
    );
};

DataProvider.propTypes = {
    children: node.isRequired,
};

export default DataProvider;
